// sportId to matchFinishPeriodId map
export const End = {
    2: [208],
    3: [304],
    4: [406],
    5: [513],
    6: [606],
    7: [710],
    8: [810],
    9: [904],
    12: [1204],
    18: [1810],
    19: [1905],
    20: [2017],
    28: [2802],
    29: [2974],
    30: [3010],
    31: [3110, 4106],
    32: [3204],
    34: [3410],
    35: [3504],
    36: [3610],
    37: [3701],
    38: [3801, 4206],
    39: [3901],
    40: [4001],
    41: [4106],
    42: [4206]
};

// sportId to matchBreakPeriodId map
export const Break = {
    7: [702, 704, 706, 708],
    8: [802, 804, 806, 808],
    9: [902],
    12: [1202],
    18: [1802, 1804, 1806, 1808],
    19: [1902, 1904],
    29: [2906, 2908, 2910, 2912,
        2914, 2964, 2966, 2968,
        2970, 2972, 2948, 2950,
        2952, 2954, 2956, 2958,
        2960, 2962, 2932, 2934,
        2936, 2938, 2940, 2942,
        2944, 2946, 2916, 2918,
        2920, 2922, 2924, 2926,
        2928, 2930, 2902, 2904],
    30: [3002, 3004, 3006, 3008],
    31: [3108, 3106, 3104, 3102, 4102, 4104],
    34: [3402, 3404, 3406, 3408],
    35: [3502],
    36: [3602, 3604, 3606, 3608],
    41: [4102, 4104]
};

// sportId to matchBreakPeriodId map
export const BreakWithoutTimer = {
    7: [702, 704, 706, 708],
    19: [1902, 1904],
    30: [3002, 3004, 3006, 3008],
    31: [3108, 3106, 3104, 3102, 4102, 4104],
    41: [4102, 4104]
};



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/constants/MatchPeriod.js